import { FunctionaProfile } from './globals';

export function showDialogAction(id: string, dialog: React.ReactElement) {
    return {
        type: 'SHOW_DIALOG',
        id,
        dialog
    };
}

export function closeDialogAction(dialogId: string) {
    return {
        type: 'CLOSE_DIALOG',
        dialogId
    };
}

export function showLoadingAction(showLoading: boolean) {
    return {
        type: 'SHOW_LOADING',
        showLoading
    };
}

export function setPriceFormatter(priceFormatter: Intl.NumberFormat) {
    return {
        type: 'PRICE_FORMATTER',
        priceFormatter
    };
}

export function setFunctionalProfiles(functionalProfile: FunctionaProfile) {
    return {
        type: 'FUNCTIONAL_PROFILE',
        functionalProfile
    };
}

export function setLastUsedTool(lastUsedTool: number) {
    return {
        type: 'LAST_USED_TOOL',
        lastUsedTool
    };
}
